import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DocumentSnapshot } from 'firebase/firestore';
import { Chat } from '../types/chat';
import { RootState } from './store';

interface EditingChatsState {
  chats: Chat[];
  hasMoreChats: boolean;
  lastVisibleChat: DocumentSnapshot<any> | null;
}

const initialState: EditingChatsState = {
  chats: [],
  hasMoreChats: true,
  lastVisibleChat: null,
};

const editingChatsSlice = createSlice({
  name: 'editingChats',
  initialState,
  reducers: {
    setEditingChats: (state, action: PayloadAction<Chat[]>) => {
      state.chats = action.payload;
    },
    addEditingChats: (state, action: PayloadAction<Chat[]>) => {
      state.chats = [...state.chats, ...action.payload];
    },
    setHasMoreEditingChats: (state, action: PayloadAction<boolean>) => {
      state.hasMoreChats = action.payload;
    },
    setLastVisibleChat: (state, action: PayloadAction<DocumentSnapshot<any> | null>) => {
      state.lastVisibleChat = action.payload;
    },
  },
});

export const {
  setEditingChats,
  addEditingChats,
  setHasMoreEditingChats,
  setLastVisibleChat,
} = editingChatsSlice.actions;

export const selectEditingChats = (state: RootState) => state.editingChats.chats;
export const selectHasMoreEditingChats = (state: RootState) => state.editingChats.hasMoreChats;
export const selectLastVisibleChat = (state: RootState) => state.editingChats.lastVisibleChat;

export default editingChatsSlice.reducer;
